import React from 'react';

import { FileUpload } from '@unimed-fesp/components';

import {
  Container,
  ContentText,
  ContentFile,
  IconAlert,
  IconsSuccess,
} from './styles';

const LoagingFiles = ({
  files,
  onClickCancel,
  canImport,
  handleProgress,
  width,
  maxLengthFileName,
}) => {
  return (
    <Container width={width}>
      {canImport ? (
        <ContentText>
          <IconsSuccess />
          Arquivo carregado com sucesso!
        </ContentText>
      ) : (
        <ContentText>
          <IconAlert />
          Aguarde! Seus arquivos estão sendo carregados.
        </ContentText>
      )}
      {Object.values(files).map((file) => (
        <MyContentFile
          file={file}
          uploadProgress={handleProgress}
          onClickCancel={onClickCancel}
          maxLengthFileName={maxLengthFileName}
        />
      ))}
    </Container>
  );
};

const MyContentFile = ({
  file,
  uploadProgress,
  onClickCancel,
  maxLengthFileName,
}) => {
  return (
    <ContentFile key={file.id}>
      <FileUpload
        fileName={
          maxLengthFileName && file.name.length > maxLengthFileName
            ? `${file.name.substr(0, maxLengthFileName)}...`
            : file.name
        }
        fileSize={file.readableSize}
        uploadProgress={uploadProgress(file)}
        onClickCancel={onClickCancel}
      />
    </ContentFile>
  );
};
export default LoagingFiles;
